import {
  customerMarketShopfrontApi,
  customerMarketShopfrontJobsApi,
  marketApi
} from '@envato/foundation-types'

import {
  ActionTypes as TopSellersActionTypes,
  TypeKeys as TopSellersTypeKeys
} from '../actions/topSellersPage'

export interface IState {
  readonly topSellers?: customerMarketShopfrontJobsApi.IBaseResult
  readonly featuredAuthors?: customerMarketShopfrontJobsApi.IFeaturedAuthorsResult
  readonly metadata: customerMarketShopfrontApi.ISeoMetadata | null
  readonly subcategories?: marketApi.ICategory[]
  readonly currentCategoryName?: string
  readonly isLoading: boolean
}

const initialState: IState = {
  topSellers: undefined,
  isLoading: false,
  metadata: null
}

export const reducer = (
  state = initialState,
  action: TopSellersActionTypes
): IState => {
  switch (action.type) {
    case TopSellersTypeKeys.GET_TOP_SELLERS_PAGE_API_REQUEST:
      return {
        ...state,
        topSellers: undefined,
        isLoading: true
      }

    case TopSellersTypeKeys.GET_TOP_SELLERS_PAGE_API_SUCCESS:
      const topSellers = action.payload.top_sellers
      const featuredAuthors = action.payload.featured_authors
      const metadata = action.payload.metadata
      const subcategories = action.payload.subcategories
      const currentCategoryName = action.payload.currentCategoryName

      return {
        topSellers,
        featuredAuthors,
        metadata,
        subcategories,
        currentCategoryName,
        isLoading: false
      }

    case TopSellersTypeKeys.GET_TOP_SELLERS_PAGE_API_FAIL:
      return {
        ...state,
        isLoading: false
      }

    default:
      return state
  }
}
